import React from 'react';
import { VALIDATION_RULES } from '@constants';
import { Input } from '@ui';
import { Col, Form, Row } from 'antd';

const ThirdRow = () => {
    return (
        <Row gutter={16}>
            <Col span={12}>
                <Form.Item name='accountNumber' rules={VALIDATION_RULES.ACCOUNT_NUMBER}>
                    <Input.Number width='100%' label='Account number' prefix={null} />
                </Form.Item>
            </Col>
            <Col span={12}>
                <Form.Item
                    name='confirmAccountNumber'
                    rules={[
                        ...VALIDATION_RULES.REQUIRED,
                        ({ getFieldValue }) => ({
                            validator(_, value) {
                                if (!value || getFieldValue('accountNumber') === value) {
                                    return Promise.resolve();
                                }
                                return Promise.reject(new Error('The account number do not match'));
                            }
                        })
                    ]}
                >
                    <Input.Number width='100%' label='Confirm account number' prefix={null} />
                </Form.Item>
            </Col>
        </Row>
    );
};

export default ThirdRow;
